import styles from './RestTimerBar.module.css'
import { formatClock } from '../../../hooks'

const RestTimerBar = ({ timer, onToggle, onAdd, onStop }) => {
  if (!timer) return null
  const finished = timer.remaining === 0
  const progress = timer.total ? (timer.remaining / timer.total) * 100 : 0

  return (
    <div className={`${styles.bar} ${finished ? styles.finished : ''}`} role="status">
      <div className={styles.track} aria-hidden="true">
        <div className={styles.fill} style={{ width: `${progress}%` }} />
      </div>
      <div className={styles.content}>
        <span className={styles.clock}>{formatClock(timer.remaining)}</span>
        <span className={styles.label}>
          {finished ? '¡A la barra!' : 'Descanso'}
          <b>{timer.label}</b>
        </span>
        <div className={styles.buttons}>
          {!finished && (
            <button type="button" onClick={onToggle}>
              {timer.running ? 'Pausar' : 'Seguir'}
            </button>
          )}
          <button type="button" onClick={() => onAdd(30)}>
            +30 s
          </button>
          <button type="button" className={styles.close} onClick={onStop} aria-label="Cerrar">
            ✕
          </button>
        </div>
      </div>
    </div>
  )
}

export default RestTimerBar
